import { I18N } from 'core';

export const periodTypeMap = [
  {
    value: '0',
    text: I18N.translate('Fleet_0303_Fleet_WorkRegime_everyday_BKeT', '每天'),
  },
  {
    value: '1',
    text: I18N.translate('Fleet_0303_Fleet_WorkRegime_weekly_fELn', '每周'),
  },
  {
    value: '2',
    text: I18N.translate('Fleet_0303_Fleet_WorkRegime_Monthly_uzwN', '每月'),
  },
];
